import { render, staticRenderFns } from "./landJu.vue?vue&type=template&id=8a1214f8&scoped=true"
import script from "./landJu.vue?vue&type=script&lang=js"
export * from "./landJu.vue?vue&type=script&lang=js"
import style0 from "./landJu.vue?vue&type=style&index=0&id=8a1214f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1214f8",
  null
  
)

export default component.exports